import { type } from '@testing-library/user-event/dist/type';
import { handleRequest } from 'msw';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { HeaderComponent, FooterComponent, ExpectDialog } from '../../shared-component';
import { api } from '@utils/api';


const DEV_NEWS_TYPE = {
  FIRST_NEWS: 'first-news',
  NEWS: 'news',
  PLACARD: 'placard',
  ACTIVITY: 'activity',
}

let newsType = DEV_NEWS_TYPE.FIRST_NEWS;
let newspage = 1;

const NewsDetailPage = ({ item }) => {
  const MockhtmlContent =
    `<p><br></p>
  <figure><img src="https://i.pinimg.com/736x/cc/76/3b/cc763bda8a77e286ad80be12b2892b24.jpg" width="300" height="200" style="float: left;">&nbsp;</figure>
  <p>123</p>
  <p>123</p>
  <p><br></p>
  <figure><img src="https://i.pinimg.com/736x/cc/76/3b/cc763bda8a77e286ad80be12b2892b24.jpg" width="300" height="300" style="float: left;">&nbsp;</figure>
  <p><br></p>
  <p>123123</p>
  <p><br></p>
  <figure><img src="https://i.pinimg.com/736x/cc/76/3b/cc763bda8a77e286ad80be12b2892b24.jpg" width="500" height="500" style="float: left;">&nbsp;</figure>
  <p><br></p>`;

  const navigate = useNavigate();
  const { id } = useParams();
  const [isPhone, setIsPhone] = useState(false);
  const [news, setNews] = useState(null);
  const [prevNews, setPrevNews] = useState(null);
  const [nextNews, setNextNews] = useState(null);

  const getNews = async (id) => {
    // 取得 query string
    const urlParams = new URLSearchParams(window.location.search);
    newsType = urlParams.get('type')
    newspage = urlParams.get('page')
    const secret = urlParams.get('secret');

    try {
      const res = await api.get(`/news?id=${id}&type=${newsType}&secret=${secret}`);
      console.log(res.data.data)

      setNews(res.data.data.news)
      setPrevNews(res.data.data.prev_news)
      setNextNews(res.data.data.next_news)

    } catch (error) {
      navigate('/news');
      console.error(error);
    }
  }

  // 等待 news.description 加載並渲染完成
  const updateFiguresHeight = () => {
    const figures = document.querySelectorAll('figure');
    console.log(figures);

    figures.forEach(figure => {
      const img = figure.querySelector('img');
      if (img) {
        // 确保圖片已加载
        img.onload = () => {
          figure.style.height = `${img.height}px`;
        };

        // 如果圖片已经加载，可以立即設置高度
        if (img.complete) {
          figure.style.height = `${img.height}px`;
        }
      }
    });
  };

  const handleBackPage = () => {
    if(newsType && newspage){
      navigate(`/news?page=${newspage}&type=${newsType}`);
    }
    else{
      navigate('/news');
    }
  }


  useEffect(() => {
    console.log('id', id)
    //setNews({description : MockhtmlContent})
    getNews(id);
    setIsPhone(window.innerWidth < 1040);
    window.addEventListener('resize', () => {
      setIsPhone(window.innerWidth < 1040);
      updateFiguresHeight();
    });
  }, []);

  useEffect(() => {
    // 找出所有的 figure 元素，將高度設定為內容 <ima> 的高度
    // 必須要等 <div dangerouslySetInnerHTML={{ __html: news?.description }} /> 執行完才能取得 img 的高度
    // 設置小延遲，以确保 HTML 渲染完成
    setTimeout(updateFiguresHeight, 500);
  }, [news]);

  return (
    <div className="cNewsDetailPage">
      <ExpectDialog />
      <HeaderComponent />
      <img className="cTitle" src={window.assetUrl(`/images/news-page/${isPhone ? 'phone' : 'pc'}-title.jpg`)} alt="" />
      <div className='cControlBox'>
        <img className="cBackPage" src={window.assetUrl('/images/news-detail-page/back_page.png')} onClick={() => { handleBackPage() }} />
        <img className="cBackTop" src={window.assetUrl('/images/news-detail-page/go-back.png')} onClick={() => { navigate('/news') }} />
      </div>
      <div className='cContentBox'>
        <img className="cCircle1" src={window.assetUrl('/images/circle.png')} alt="" />
        <img className="cCircle2" src={window.assetUrl('/images/circle.png')} alt="" />

        <div className='cNewsBox'>
          <div className='cFrame' style={{ backgroundImage: `url(${window.assetUrl('/images/news-detail-page/frame-bg.png')})` }}>
            <img className="cFrameHeader" src={window.assetUrl('/images/news-detail-page/frame-header.png')} />
            <img className='cNextArrow' src={window.assetUrl('/images/news-detail-page/next-arrow.png')} style={{ display: nextNews ? 'block' : 'none' }} onClick={() => { getNews(nextNews.id) }} />
            <img className='cPrevArrow' src={window.assetUrl('/images/news-detail-page/prev-arrow.png')} style={{ display: prevNews ? 'block' : 'none' }} onClick={() => { getNews(prevNews.id) }} />
            <div className='cFrameBody' style={{ backgroundImage: `url(${window.assetUrl('/images/news-detail-page/frame-body.png')})` }}>
              <div className='cNewsPublishAt'>{news?.publish_at.split(' ')[0]}</div>

              <div className='cNewsTitle'>{news?.title}</div>
              <div className='cContent'>
                <div dangerouslySetInnerHTML={{ __html: news?.description }} />
              </div>
              <div className='cCommunityBox'>
                <div className='cItemBox' onClick={() => { window.open("https://www.facebook.com/mahoyakuzh/") }}>
                  <img className="cItem cOn" src={window.assetUrl(`/images/welcome/fb-off.png`)} />
                  <img className="cItem cOff" src={window.assetUrl(`/images/welcome/fb-on.png`)} />
                </div>
                <div className='cItemBox' onClick={() => { window.open("https://www.instagram.com/isweetyig/") }}>
                  <img className="cItem cOn" src={window.assetUrl(`/images/welcome/ig-off.png`)} />
                  <img className="cItem cOff" src={window.assetUrl(`/images/welcome/ig-on.png`)} />
                </div>
                <div className='cItemBox' onClick={() => { window.open("https://www.plurk.com/mahoyakuzh") }}>
                  <img className="cItem cOn" src={window.assetUrl(`/images/welcome/plurk-off.png`)} />
                  <img className="cItem cOff" src={window.assetUrl(`/images/welcome/plurk-on.png`)} />
                </div>
                <div className='cItemBox' onClick={() => { window.open("https://page.line.me/ofn9823a?openQrModal=true") }}>
                  <img className="cItem cOn" src={window.assetUrl(`/images/welcome/line-off.png`)} />
                  <img className="cItem cOff" src={window.assetUrl(`/images/welcome/line-on.png`)} />
                </div>
              </div>
            </div>
            <img className="cFrameTail" src={window.assetUrl('/images/news-detail-page/frame-tail.png')} />
          </div>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default NewsDetailPage;

